'use client'

import type { SVGProps } from 'react'
import { forwardRef } from 'react'

import { cn } from '@/lib/utils'

interface CircularProgressProps extends SVGProps<SVGSVGElement> {
  size?: number // Tamanho do círculo (largura e altura)
  thickness?: number // Espessura do traço
  color?: string // Cor do traço
}

const CircularProgress = forwardRef<SVGSVGElement, CircularProgressProps>(
  (
    { className, size = 40, thickness = 4, color = '#1976d2', ...props },
    ref,
  ) => {
    const radius = (size - thickness) / 2 // Raio do círculo
    const circumference = 2 * Math.PI * radius // Circunferência do círculo

    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="progressbar"
        aria-valuemax={100}
        aria-valuemin={0}
        className={cn('text-primary animate-spin', className)}
        ref={ref}
        {...props}
      >
        {/* Background Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="none"
          strokeWidth={thickness}
        />

        {/* Progress Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={thickness}
          strokeDasharray={circumference}
          strokeDashoffset={circumference * 0.25} // Ajuste para controlar o progresso (exemplo 25%)
          strokeLinecap="round"
          style={{
            transition: 'stroke-dashoffset 0.35s', // Suaviza a animação do progresso
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
          }}
        />
      </svg>
    )
  },
)

CircularProgress.displayName = 'CircularProgress'

export { CircularProgress }
